import React, { FC, useState } from "react";
import {
  Row,
  Col,
  Button,
  Input,
  Alert,
  Form,
  Spin,
  Collapse,
  Layout,
} from "antd";
import { withRouter, RouteComponentProps, Redirect } from "react-router";
import HeaderContent from "./HeaderContent";
import axios, { AxiosRequestConfig } from "axios";

const { Header, Content, Footer } = Layout;



const AppLayout: FC<RouteComponentProps | any> = (props) => {
  

  return (
    <Layout className="layout">
      <HeaderContent />
      <Content className="site-layout">
        <div className="site-layout-background">{props.children}</div>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        © 2021 Educational Commission for Foreign Medical Graduates (ECFMG®).
        All rights reserved.
        <br />
        <a
          href="https://www.ecfmg.org/annc/terms.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>{" "}
        |{" "}
        <a
          href="https://www.ecfmg.org/annc/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
      </Footer>
    </Layout>
  );
};

export default withRouter(AppLayout);
